// @material-ui/core
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
// @material-ui/icons
import { Face as FaceIcon, Mail as MailIcon } from "@material-ui/icons";
import PropTypes from "prop-types";
import React, { Component } from "react";
import PageHeader from "../library/pages/PageHeader";

const contact = {
  phone: {
    title: "Cologne, Germany",
    content: "+49 221 669506-0"
  },
  mail: {
    title: "Email",
    content: "support@cloudpilots.com"
  }
};

const styles = theme => ({
  title: {
    marginBottom: "15px"
  }
});

class Support extends Component {
  render() {
    const { classes } = this.props;
    return (
      <Grid container>
        <Grid item xs={12}>
          <PageHeader
            title="Support"
            description="Don't freak out, we got you covered."
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography type="body2">Deutschland</Typography>
          <Typography type="subheading">
            CLOUDPILOTS Software & Consulting GmbH<br />
            <br />
            <br />
          </Typography>
          <Typography type="body1" className={classes.title}>
            Im Mediapark 5c<br />50670 Köln
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography type="body2">Österreich</Typography>
          <Typography type="subheading">
            CLOUDPILOTS Software & Consulting GmbH<br />
            c/o TIMETOACT GROUP Österreich GmbH<br />
            <br />
          </Typography>
          <Typography type="body1">
            Währinger Str. 2-4 / Stiege 1 / Top 29<br />A-1090 Wien
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <List dense>
            <ListItem
              button
              onClick={() => (window.location = "mailto:info@cloudpilots.com")}>
              <ListItemIcon>
                <MailIcon />
              </ListItemIcon>
              <ListItemText
                primary={contact.mail.content}
                secondary={contact.mail.title}
              />
            </ListItem>
            <ListItem
              button
              onClick={() =>
                (window.location =
                  "https://cloudpilots.freshdesk.com/de/support/home")
              }>
              <ListItemIcon>
                <FaceIcon />
              </ListItemIcon>
              <ListItemText primary="Helpdesk" secondary="Freshdesk" />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    );
  }
}

Support.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Support);



// WEBPACK FOOTER //
// ./src/pages/Support.js